import API_BASE from './config';

export function getQuestions(raceId) {
    return fetch(`${API_BASE}/questions?raceId=${encodeURIComponent(raceId)}`, {
        headers: { 'Accept': 'application/json' },
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to fetch questions');
            return res.json();
        });
}

export function createQuestion(data) {
    return fetch(`${API_BASE}/questions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to create question');
            return res.json();
        });
}

export function updateQuestion(id, data) {
    return fetch(`${API_BASE}/questions/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to update question');
            return res.json();
        });
}

export function deleteQuestion(id) {
    return fetch(`${API_BASE}/questions/${id}`, {
        method: 'DELETE',
        headers: { 'Accept': 'application/json' },
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to delete question');
            return res.json();
        });
}
